import { render, staticRenderFns } from "./LogNotes.vue?vue&type=template&id=30108273&"
import script from "./LogNotes.vue?vue&type=script&lang=js&"
export * from "./LogNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports